import script from "./CardFooterIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFooterIcons.vue?vue&type=script&setup=true&lang=js"

import "./CardFooterIcons.vue?vue&type=style&index=0&id=0853cfb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0853cfb2"]])

export default __exports__